import React, { useMemo } from 'react';
import BaseGrid from 'components/atoms/base-grid';
import SmsCampaignsPageHeader from 'components/organisms/sms-campaigns/page-header';
import SmsCampaignsResponsesTableFilters from 'components/organisms/sms-campaigns/responses/table-filters';
import { useSmsCampaignsResponseQueryFilter } from 'infrastructure/hooks/sms-campaigns/use-sms-campaigns-responses-query-filter';
import SmsCampaignsAnswersTable from 'components/organisms/sms-campaigns/responses/table';
import { useLocation, useParams } from 'react-router-dom';
import { isValidGuid } from 'infrastructure/functions';

import s from './styles.module.scss';

const SmsCampaignResponsesPage: React.FC = () => {
  const { campaignGuid } = useParams();
  if (!campaignGuid || !isValidGuid(campaignGuid)) {
    return null;
  }

  const { state } = useLocation();

  const { filter, resetFilter, updateFilter } =
    useSmsCampaignsResponseQueryFilter();

  const count = useMemo<number>(() => {
    if (filter.questionAnswers)
      return Object.keys(JSON.parse(filter.questionAnswers)).length;
    return 0;
  }, [filter.questionAnswers]);

  return (
    <BaseGrid className={s.wrapper} rowGap={40}>
      <SmsCampaignsPageHeader campaignGuid={campaignGuid} name={state?.name} />
      <SmsCampaignsResponsesTableFilters
        filters={filter}
        updateFilter={updateFilter}
        resetFilter={resetFilter}
        count={count}
        campaignGuid={campaignGuid}
      />
      <SmsCampaignsAnswersTable filters={filter} campaignGuid={campaignGuid} />
    </BaseGrid>
  );
};

export default SmsCampaignResponsesPage;
